import React, { useState } from "react";
import UpsellModal from "../../../../shared/UpsellModal";
import AuditLogsLoadingStateTable from "./AuditLogsLoadingStateTable";
import { ReactComponent as FDAuditLogs } from "../../../../../assets/svg/feature-discovery/feature-discovery-audit-logs.svg";

// constants
const MODAL_WIDTH_VALUE = "476px";

const AuditLogsUpsellModal = () => {
  const [showUpsellModal, setShowUpsellModal] = useState(true);

  return (
    <>
      <UpsellModal
        modalTitle="Audit trail"
        customImage={<FDAuditLogs className="-ml-2 mb-6" />}
        modalBodyText={
          <>
            <p>Need to know who did what, where, and when?</p>
            <p>Track all activity for your organization with a detailed audit trail.</p>
            <div className="text-sm text-gray-40 mt-3 mb-6">
              Unlock this feature with our Enterprise plan.
            </div>
          </>
        }
        includeLearnMoreButton={false}
        includeModalCloseOption={false}
        showModal={showUpsellModal}
        setShowModal={setShowUpsellModal}
        modalWidthValue={MODAL_WIDTH_VALUE}
        upsellButtonId="upsell_button_audit_trail"
        learnMoreButtonId="learn_more_button_audit_trail"
      />
      <div className="opacity-50">
        <AuditLogsLoadingStateTable />
      </div>
    </>
  );
};

export default AuditLogsUpsellModal;
